import axios from 'axios';
import {defineStore} from "pinia";
import {ref} from "vue";

export const useReviewsStore = defineStore('reviews', {
	state: () => ({
		reviews: {
			items: ref([]),
			currentPage: 1,
			lastPage: 1,
			perPage: 10,
			total: 3661,
			next_page_url: '',
			prev_page_url: '',
			average_rating: ref([]),
			rating_count: ref([]),
		},
		lastFetched: null,
		isLoading: false,
		show: {
			review_box: false,
		},
	}),

	getters: {
		shouldFetchReviews: (state) => {
			const now = Date.now();
			const oneHour = 60 * 60 * 1000;
			return state.reviews.items.length === 0 || !state.lastFetched || (now - state.lastFetched > oneHour);
		},
		getReviewsFilterByStars: (state) => (starsAndAbove, limit = 100) => {
			if (state.reviews.rating_count.length === 0) return [];

			const filteredReviews = state.reviews.items.filter(item => item.rating >= starsAndAbove && item.description);
			return limit ? filteredReviews.slice(0, limit) : filteredReviews;
		},
		ratingText: (state) => {
			if (!state.reviews?.average_rating.length) return 'Sehr gut';
			const rating = state.reviews.average_rating.find(item => item.plattform === 'all')?.average_rating || 0;
			if (rating >= 4.5) return 'Sehr gut';
			if (rating >= 3.5) return 'Gut';
			if (rating >= 2.5) return 'Befriedigend';
			if (rating >= 1.5) return 'Ausreichend';
			return 'Mangelhaft';
		},
		averageRating: (state) => {
			if (!Array.isArray(state.reviews.average_rating) || state.reviews.average_rating.length === 0) return 4.72;
			return state.reviews.average_rating.find(item => item.plattform === 'all').average_rating ?? 4.72;
		},
		ratingCountStars: (state) => (stars) => {
			if (state.reviews.rating_count.length === 0) return 3661;
			return state.reviews.rating_count.find(item => item.rating === stars)?.rating_count || 3661;
		},
	},

	actions: {
		async fetchReviews() {
			if (this.isLoading) return;

			this.isLoading = true;
			try {
				let pushOrSet = 'set';
				let url = `https://app.immobilienwerker.de/api/reviews?page=1`;
				if (process.env.NODE_ENV !== 'production') {
					url = url.replace('app.', 'dev.app.');
				}

				if (this.reviews.next_page_url) {
					url = this.reviews.next_page_url;
					pushOrSet = 'push';
				}
				const response = await axios.get(url);

				if (pushOrSet === 'push') {
					this.reviews.items.push(...response.data.data);
					this.reviews.next_page_url = response.data.next_page_url;
					this.reviews.prev_page_url = response.data.prev_page_url;
				} else {
					this.reviews.items = response.data.data;
					this.reviews.currentPage = response.data.current_page;
					this.reviews.lastPage = response.data.last_page;
					this.reviews.perPage = response.data.per_page;
					this.reviews.total = response.data.total;
					this.reviews.average_rating = response.data.average_rating;
					this.reviews.rating_count = response.data.rating_count;
					this.reviews.next_page_url = response.data.next_page_url;
					this.reviews.prev_page_url = response.data.prev_page_url;
				}
				this.lastFetched = Date.now();
			} catch (error) {
				console.error('Error fetching reviews:', error);
			} finally {
				this.isLoading = false;
			}
		},
		async loadMoreReviews() {
			if (!this.reviews.next_page_url) return;
			this.fetchReviews()

		},
	},
	persist: true,
});
